import { Accept } from "react-dropzone";

/**
 * The sidecar extensions that make up a single readable dataset.
 *
 * Every extension listed in a group is required.
 */
export const FILE_BUNDLE_EXTENSIONS: readonly (readonly string[])[] = [
  ["shp", "dbf", "prj", "shx"],
  // The backend supports importing TAB files without a .map file (i.e. without geometry), but
  // in UI contexts where the user is intending to upload a geometry (e.g. uploading a multi-project boundary),
  // we don't want to allow that.
  ["tab", "dat", "id", "map"],
  ["kml"],
  ["geojson"],
];

/** File extensions accepted by a geospatial dropzone, keyed by mime type. */
export const GEOSPATIAL_FILE_ACCEPT: Accept = {
  "application/vnd.google-earth.kmz": [".kml"],
  "application/geo+json": [".geojson"],
  "application/x-dbf": [".dbf"],
  "application/unknown": [".prj", ".tab", ".dat", ".id", ".map", ".shp", ".shx"],
};

/** Dropzone caption naming the accepted formats. */
export const GEOSPATIAL_FILE_CAPTION = "SHAPE, TAB, KML and GEOJSON files are allowed";
